import React, { Component } from 'react'
import Table from '@common/Table'
import columns from './columns'
export default class extends Component {
  render() {
    return (
      <Table store={this.props.store} columns={columns(this.props.store)} />
    )
  }
}
